module.exports = __webpack_public_path__ + "img/arrow-down.be4b3765.svg";